import React from "react";
import SevenSegmentTimer from "./SevenSegmentTimer";
import "./index.css";

export default function App() {
  return <SevenSegmentTimer />;
}
